import { render } from "./LandingPageResolver.vue?vue&type=template&id=21cb6aa2"
import script from "./LandingPageResolver.vue?vue&type=script&lang=js"
export * from "./LandingPageResolver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__